import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class DeepSeaMediumPiratesSalvageableTileEntity extends TileEntity {
	public static readonly frameName = FrameName.DEEP_SEA_MEDIUM_PIRATES;
}

export default DeepSeaMediumPiratesSalvageableTileEntity;
